import { render, staticRenderFns } from "./brandsIndex.vue?vue&type=template&id=03150f6a&scoped=true"
import script from "./brandsIndex.vue?vue&type=script&lang=js"
export * from "./brandsIndex.vue?vue&type=script&lang=js"
import style0 from "./brandsIndex.vue?vue&type=style&index=0&id=03150f6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03150f6a",
  null
  
)

export default component.exports